import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';
import { useConfirmDialog, useUIStore } from '@/store';

/**
 * Global confirm dialog component
 * Replaces Angular's ConfirmDialogComponent
 */
export const ConfirmDialog: React.FC = () => {
  const { isOpen, options } = useConfirmDialog();
  const closeConfirm = useUIStore((state) => state.closeConfirm);

  if (!options) return null;

  const handleCancel = () => {
    closeConfirm(false);
  };

  const handleConfirm = () => {
    closeConfirm(true);
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleCancel}
      aria-labelledby="confirm-dialog-title"
      aria-describedby="confirm-dialog-description"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle id="confirm-dialog-title">{options.title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="confirm-dialog-description">
          {options.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="inherit">
          {options.cancelText}
        </Button>
        <Button
          onClick={handleConfirm}
          color={options.confirmColor}
          variant="contained"
          autoFocus
        >
          {options.confirmText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
